import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { Proposal, ProposalItem } from '@/models/Coupon';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';


export class ProposalsService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();
    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getProposals(form: any, id?: number) {
        const path = id ?
            `${this.baseAPI}/proposals/${id}` :
            `${this.baseAPI}/proposals?q=kyotenCd=${form.kyotenCd},groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getProposals');
            return;
        }
    }

    public async editProposal(data: ProposalItem) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/proposals/`, { ...data });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editProposal');
            return;
        }
    }

    public async deleteProposal(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/proposals/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteProposal');
            return;
        }
    }

    public async saveProposals(data: any[], base: any) {
        const q = `groupCd=${base.groupCd},shatenCd=${base.shatenCd},kyotenCd=${base.kyotenCd}`;
        const { result, error } = await this.commonService.put(`${this.baseAPI}/proposals-order-display?q=${q}`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveProposals');
            return;
        }
    }
    
    public async cloneData(data: any[]) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/proposals-clone`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async getShowFlag(form: any) {
        let path = `${this.baseAPI}/displayoption?q=kyotenCd=${form.kyotenCd}`;
        path += `,groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getShowFlag');
            return;
        }
    }

    public async saveShowProposal(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/displayoption`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

}
